import React from 'react';
import { Page } from '../../../../../../../../components/Print/Print';
import poweredByLogo from '../../../../assets/powered-by-lmi.png';
import './MarshBackCover.scss';

// Marsh back cover / legal page — replaces the default back cover for Marsh reports.
// Content and layout per docs/marsh-ribbon-styles/README.md (aligned with MarshCover).
const MarshBackCover = () => {
  return (
    <Page>
      <div className="marsh-report-preview-back-cover">
        <div className="company-logo" />
        <div className="company-details">
          <div className="company-name">Marsh Pty Ltd</div>
          <div>ABN 86 004 651 512</div>
          <div>One International Towers Sydney</div>
          <div>100 Barangaroo Avenue</div>
          <div>Sydney, NSW Australia 2000</div>
          <div>PO Box H176</div>
          <div>Australia Square, Sydney, NSW 1215</div>
          <div>www.marsh.com.au</div>
        </div>
        <div className="legal-copy">
          <p>Marsh Pty Ltd (ABN 86 004 651 512, AFSL 238 983).</p>
          <p>
            This document and any recommendations, analysis, or advice provided by Marsh (collectively, the
            &ldquo;Marsh Analysis&rdquo;) are not intended to be taken as advice regarding any individual situation and
            should not be relied upon as such. The information contained herein is based on sources we believe
            reliable, but we make no representation or warranty as to its accuracy. Marsh shall have no obligation to
            update the Marsh Analysis and shall have no liability to you or any other party arising out of this
            publication or any matter contained herein. Any statements concerning actuarial, tax, accounting, or legal
            matters are based solely on our experience as insurance brokers and risk consultants and are not to be
            relied upon as actuarial, tax, accounting, or legal advice, for which you should consult your own
            professional advisors. Any modelling, analytics, or projections are subject to inherent uncertainty, and
            the Marsh Analysis could be materially affected if any underlying assumptions, conditions, information, or
            factors are inaccurate or incomplete or should change. Marsh makes no representation or warranty concerning
            the application of policy wording or the financial condition or solvency of insurers or reinsurers. Marsh
            makes no assurances regarding the availability, cost, or terms of insurance coverage. Although Marsh may
            provide advice and recommendations, all decisions regarding the amount, type or terms of coverage are the
            ultimate responsibility of the insurance purchaser, who must decide on the specific coverage that is
            appropriate to its particular circumstances and financial position.
          </p>
          <p className="copyright">{`© ${new Date().getFullYear()} Marsh. All rights reserved.`}</p>
        </div>
        <div className="powered-by-container">
          <img src={poweredByLogo} height={60} alt="lmi-logo" />
        </div>
      </div>
    </Page>
  );
};

export default MarshBackCover;
